import { Component, OnInit, OnDestroy, AfterViewChecked, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';
import { UnifiedAgentPage } from 'src/pages/unified-agent/unified-agent';

@Component({
  templateUrl: 'mobile-agent-trigger-detail.page.html',
  standalone: false,
})
export class MobileAgentTriggerDetailPage implements OnInit, AfterViewChecked, OnDestroy {

  triggerKey: string | null = null;

  @ViewChild(UnifiedAgentPage) unifiedAgent: UnifiedAgentPage;

  private lastLoadingState: boolean | null = null;

  constructor(
    private route: ActivatedRoute,
    private navCtrl: CustomNavController,
    private windowService: WindowService,
  ) {}

  ngOnInit() {
    const raw = this.route.snapshot.paramMap.get('key');
    this.triggerKey = raw ? decodeURIComponent(raw) : null;
  }

  get isLoading(): boolean {
    return !this.unifiedAgent?.loaded
      || !!this.unifiedAgent?.isLoadingTrigger
      || !!this.unifiedAgent?.showLoadingSpinner;
  }

  // Toggle the top-nav's built-in .js-tidy-loading bar while this page is
  // loading — matches the pattern used by src/pages/chat/chat.page.ts.
  ngAfterViewChecked() {
    if (this.windowService.isDesktopRes) {
      return;
    }
    const current = this.isLoading;
    if (current === this.lastLoadingState) {
      return;
    }
    this.lastLoadingState = current;
    const bars = document.querySelectorAll('.js-tidy-loading') as NodeListOf<HTMLElement>;
    bars.forEach(bar => bar.style.display = current ? 'block' : 'none');
  }

  ngOnDestroy() {
    if (!this.windowService.isDesktopRes) {
      const bars = document.querySelectorAll('.js-tidy-loading') as NodeListOf<HTMLElement>;
      bars.forEach(bar => bar.style.display = 'none');
    }
  }

  goToActivity() {
    if (!this.triggerKey) {
      return;
    }
    const key = encodeURIComponent(this.triggerKey);
    this.navCtrl.navigateForward(`agent/triggers/${key}/activity`);
  }
}
